import { SuggestionResult } from "@/interfaces/suggestions-result.interface";
import getPortalFacetFilter from "@/utils/PortalFacetFilter";
import { BaseSuperAgentRequestFactory, RequestSender } from "@studyportals/mb-platform-http-requests/base";
import { ProgrammeSearchFilters, ProgrammeSearchInput, SearchApiProgrammeClient, TextSearchAlgorithmType } from "@studyportals/search-api-interface";

declare const SEARCH_API_URL: string;

export default class SuggestionsRepository {
	private readonly searchApiProgrammeClient: SearchApiProgrammeClient;
	private readonly baseSuperAgentRequestFactory: BaseSuperAgentRequestFactory;
	private readonly requestSender: RequestSender;

	constructor() {
		this.baseSuperAgentRequestFactory = new BaseSuperAgentRequestFactory();
		this.requestSender = new RequestSender();
		this.searchApiProgrammeClient = new SearchApiProgrammeClient(
			SEARCH_API_URL,
			this.baseSuperAgentRequestFactory,
			this.requestSender
		);
	}

	public async getSuggestions(input: ProgrammeSearchInput): Promise<SuggestionResult[]|null> {
		const portalFilter: ProgrammeSearchInput = getPortalFacetFilter();

		const result = await this.searchApiProgrammeClient.searchCards(new ProgrammeSearchFilters().from({
			...input,
			...portalFilter,
			textSearchAlgorithm: TextSearchAlgorithmType.SIMILARITY_SEARCH,
			suggestionSize: 6
		}), 0, 0);
		if(result.suggestions){
			return result.suggestions as unknown as SuggestionResult[];
		}
		return null;
	}


}
